// International Pride Softball - Theme JS

document.addEventListener('DOMContentLoaded', function () {

  // ============================================================
  // MOBILE MENU
  // ============================================================
  const mobileToggle = document.getElementById('mobile-menu-toggle');
  const mobileNav = document.getElementById('mobile-nav');
  if (mobileToggle && mobileNav) {
    mobileToggle.addEventListener('click', function () {
      mobileNav.classList.toggle('is-open');
      const isOpen = mobileNav.classList.contains('is-open');
      mobileToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });
  }

  // ---- Smooth scroll for anchor links ----
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // ---- Simple counter animation for stat numbers ----
  function animateCounter(el) {
    const target = parseFloat(el.dataset.target) || parseInt(el.textContent.replace(/[^0-9]/g, ''));
    const prefix = el.dataset.prefix || '';
    const suffix = el.dataset.suffix || '';
    const duration = 1800;
    const start = performance.now();

    function update(now) {
      const elapsed = now - start;
      const progress = Math.min(elapsed / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      const current = Math.round(eased * target);
      el.textContent = prefix + current.toLocaleString() + suffix;
      if (progress < 1) requestAnimationFrame(update);
    }

    requestAnimationFrame(update);
  }

  // Intersection observer for counters
  const counterEls = document.querySelectorAll('[data-counter]');
  if (counterEls.length && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          animateCounter(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });

    counterEls.forEach(function (el) { observer.observe(el); });
  }

  // ---- Slideshow / Carousel (simple) ----
  document.querySelectorAll('.slideshow').forEach(function (slideshow) {
    const slides = slideshow.querySelectorAll('.slide');
    const prevBtn = slideshow.querySelector('.slide-prev');
    const nextBtn = slideshow.querySelector('.slide-next');
    let current = 0;

    function showSlide(n) {
      slides.forEach(function (s) { s.classList.remove('active'); });
      current = (n + slides.length) % slides.length;
      slides[current].classList.add('active');
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { showSlide(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { showSlide(current + 1); });

    if (slides.length) showSlide(0);
  });

});


document.addEventListener('DOMContentLoaded', function () {

  // ============================================================
  // COUNTDOWN TIMER
  // ============================================================
  const timerEl = document.getElementById('countdown-timer');
  if (timerEl) {
    const targetDate = timerEl.dataset.target;
    const target = new Date(targetDate + 'T00:00:00');

    function updateCountdown() {
      const now = new Date();
      const diff = target - now;

      if (diff <= 0) {
        document.getElementById('days').textContent = '00';
        document.getElementById('hours').textContent = '00';
        document.getElementById('minutes').textContent = '00';
        document.getElementById('seconds').textContent = '00';
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      document.getElementById('days').textContent = String(days).padStart(2, '0');
      document.getElementById('hours').textContent = String(hours).padStart(2, '0');
      document.getElementById('minutes').textContent = String(minutes).padStart(2, '0');
      document.getElementById('seconds').textContent = String(seconds).padStart(2, '0');
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
  }

  // ============================================================
  // FAQ ACCORDION
  // ============================================================
  const faqItems = document.querySelectorAll('.faq-item');
  faqItems.forEach(function (item) {
    const btn = item.querySelector('.faq-item__question');
    if (!btn) return;
    btn.addEventListener('click', function () {
      const isOpen = item.classList.contains('is-open');
      // Close all
      faqItems.forEach(function (i) {
        i.classList.remove('is-open');
        const b = i.querySelector('.faq-item__question');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
      // Toggle clicked
      if (!isOpen) {
        item.classList.add('is-open');
        btn.setAttribute('aria-expanded', 'true');
      }
    });
  });



  // ============================================================
  // STICKY HEADER SHADOW
  // ============================================================
  const header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 10) {
        header.style.boxShadow = '0 4px 16px rgba(26,43,74,0.15)';
      } else {
        header.style.boxShadow = '0 2px 8px rgba(26,43,74,0.08)';
      }
    }, { passive: true });
  }

});


  // ============================================================
  // Carousel
  // ============================================================

  (function () {
  const section = document.querySelector('.carousel-section');
  if (!section) return;

  const track = section.querySelector('.carousel-section__track');
  const prevBtn = section.querySelector('.carousel-section__arrow--prev');
  const nextBtn = section.querySelector('.carousel-section__arrow--next');
  const slides = Array.from(section.querySelectorAll('.carousel-section__slide'));

  const ITEMS_PER_PAGE = 3;
  let currentIndex = 0;
  let isDragging = false;
  let startX = 0;
  let currentTranslate = 0;
  let prevTranslate = 0;

  function getSlideStep() {
    const slide = slides[0];
    if (!slide) return 0;
    const gap = parseFloat(getComputedStyle(track).gap) || 0;
    return slide.offsetWidth + gap;
  }

  function getMaxIndex() {
    return Math.max(0, slides.length - ITEMS_PER_PAGE);
  }

  function clampIndex(index) {
    return Math.max(0, Math.min(index, getMaxIndex()));
  }

  function getTranslateForIndex(index) {
    return -(index * getSlideStep());
  }

  function setTrackPosition(translate, animate) {
    track.style.transition = animate ? 'transform 0.45s cubic-bezier(0.25, 0.46, 0.45, 0.94)' : 'none';
    track.style.transform = `translateX(${translate}px)`;
  }

  function updateUI(animate) {
    currentIndex = clampIndex(currentIndex);
    currentTranslate = getTranslateForIndex(currentIndex);
    prevTranslate = currentTranslate;
    setTrackPosition(currentTranslate, animate);

    prevBtn.disabled = currentIndex === 0;
    nextBtn.disabled = currentIndex >= getMaxIndex();
  }

  function goNext() {
    currentIndex = clampIndex(currentIndex + ITEMS_PER_PAGE);
    updateUI(true);
  }

  function goPrev() {
    currentIndex = clampIndex(currentIndex - ITEMS_PER_PAGE);
    updateUI(true);
  }

  function onPointerDown(event) {
    isDragging = true;
    startX = event.clientX;
    track.style.transition = 'none';
    track.setPointerCapture(event.pointerId);
  }

  function onPointerMove(event) {
    if (!isDragging) return;
    const delta = event.clientX - startX;
    currentTranslate = prevTranslate + delta;
    setTrackPosition(currentTranslate, false);
  }

  function onPointerUp(event) {
    if (!isDragging) return;
    isDragging = false;
    track.releasePointerCapture(event.pointerId);

    const delta = event.clientX - startX;
    const threshold = getSlideStep() * 0.2;

    if (delta < -threshold) {
      goNext();
    } else if (delta > threshold) {
      goPrev();
    } else {
      updateUI(true);
    }
  }

  prevBtn.addEventListener('click', goPrev);
  nextBtn.addEventListener('click', goNext);

  track.addEventListener('pointerdown', onPointerDown);
  track.addEventListener('pointermove', onPointerMove);
  track.addEventListener('pointerup', onPointerUp);
  track.addEventListener('pointercancel', onPointerUp);

  window.addEventListener('resize', () => updateUI(false));

  updateUI(false);
})();

// ============================================================
// HEADSHOTS
// ============================================================

(function () {
  'use strict';

  function HeadshotsBio(section) {
    this.section = section;
    this.modal = section.querySelector('.headshots-bio-modal');
    this.overlay = section.querySelector('.headshots-bio-modal__overlay');
    this.dialog = section.querySelector('.headshots-bio-modal__dialog');
    this.closeButton = section.querySelector('.headshots-bio-modal__close');
    this.nameEl = section.querySelector('.headshots-bio-modal__name');
    this.roleEl = section.querySelector('.headshots-bio-modal__role');
    this.textEl = section.querySelector('.headshots-bio-modal__text');
    this.triggers = section.querySelectorAll('.team-card__bio-trigger');
    this.lastFocus = null;

    if (!this.modal || !this.triggers.length) {
      return;
    }

    this.bindEvents();
  }

  HeadshotsBio.prototype.bindEvents = function () {
    var self = this;

    this.triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function (event) {
        event.preventDefault();
        self.openFromTrigger(trigger);
      });
    });

    this.closeButton.addEventListener('click', function (event) {
      event.preventDefault();
      self.close();
    });

    this.overlay.addEventListener('click', function () {
      self.close();
    });

    this.modal.addEventListener('click', function (event) {
      if (event.target === self.modal) {
        self.close();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && self.modal.classList.contains('is-open')) {
        self.close();
      }
    });
  };

  HeadshotsBio.prototype.openFromTrigger = function (trigger) {
    var targetId = trigger.getAttribute('data-bio-target');
    var source = targetId ? document.getElementById(targetId) : null;
    var memberName = trigger.getAttribute('data-member-name') || '';
    var memberRole = trigger.getAttribute('data-member-role') || '';

    if (!source) {
      return;
    }

    this.lastFocus = document.activeElement;
    this.nameEl.textContent = memberName;
    this.roleEl.textContent = memberRole;
    this.textEl.innerHTML = source.innerHTML;

    this.modal.hidden = false;
    this.modal.classList.add('is-open');
    this.modal.setAttribute('aria-hidden', 'false');
    this.dialog.setAttribute('aria-labelledby', 'headshots-bio-name-' + this.section.dataset.sectionId);
    this.nameEl.id = 'headshots-bio-name-' + this.section.dataset.sectionId;

    document.body.style.overflow = 'hidden';
    this.closeButton.focus();
  };

  HeadshotsBio.prototype.close = function () {
    this.modal.classList.remove('is-open');
    this.modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';

    var self = this;
    window.setTimeout(function () {
      if (!self.modal.classList.contains('is-open')) {
        self.modal.hidden = true;
        self.textEl.innerHTML = '';
      }
    }, 200);

    if (this.lastFocus && typeof this.lastFocus.focus === 'function') {
      this.lastFocus.focus();
    }
  };

  function init() {
    document.querySelectorAll('.headshots-section[data-section-id]').forEach(function (section) {
      new HeadshotsBio(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

